export default __webpack_public_path__ + "static/media/profile-preview-icon.a3c9710e.svg";